import { Component, OnInit } from '@angular/core';
import { ConnectionLogsModalComponent } from '@components/connection-logs-modal/connection-logs-modal.component';
import { User } from '@interfaces/user';
import { ModalController } from '@ionic/angular';
import { AnalyticsService, ParamType } from '@services/analytics.service';
import { AuthService } from '@services/auth.service';
import { RestService } from '@services/rest.service';
import { SipService } from '@services/sip.service';
import { SubscribeEventsService } from '@services/subscribe-events.service';

@Component({
  selector: 'app-lateral-menu',
  templateUrl: './lateral-menu.component.html',
  styleUrls: ['./lateral-menu.component.scss'],
})
export class LateralMenuComponent implements OnInit {
  pagesList: string[] = [];
  currentUser?: User;
  connectionStatus = 'disconnected';

  constructor(
    private rest: RestService,
    private auth: AuthService,
    private subscribeEv: SubscribeEventsService,
    private analytics: AnalyticsService,
    private sip: SipService,
    private modalCtrl: ModalController
  ) {
    this.subscribeEv.observeUser().subscribe(async user => {
      console.log('user', user);
      if (user) {
        await this.getCurrentUser(true);
        this.createMenuSections();
      }
    });

    // 🔥 Observa el estado de conexión del servicio SIP centralizado
    this.sip.connectionState$.subscribe(status => {
      this.connectionStatus = status === 'connected' ? 'connected' : 'disconnected';
    });
  }

  async ngOnInit() {
    await this.getCurrentUser();
    this.createMenuSections();
  }

  async getCurrentUser(force = false) {
    const resp = await this.rest.getCurrentUser(force);
    if (resp) {
      this.currentUser = resp;
    }
  }

  createMenuSections() {
    if (this.currentUser?.role?.includes('manager') && !this.currentUser?.role?.includes('operator')) {
      this.pagesList = [
        '',
        'realtime',
        'services',
        'scheduled',
        'taxi',
        'drivers',
        'sessions',
        'clients',
        'hotels',
        'messages',
        'provinces',
        'zones',
        // 'operators',
        'delivery-system',
        'incidents',
        'archive',
        'stats'
      ];
    } else if (this.currentUser?.role?.includes('admin')) {
      this.pagesList = [
        '',
        // 'services',
        'taxi',
        // 'scheduled',
        // 'clients',
        // 'messages',
        // 'zones',
        // 'drivers',
        'managers',
        'provinces',
        'configuration',
        'control',
        'zones',
        'global-zones',
        'price-simulator',
        'contracts',
        'payments',
        'invoices'
        //'operators',
        // 'incidents',
        // 'sessions',
        // 'metrics',
        // 'history',
        // 'archive'
      ];
    } else if (this.currentUser?.role?.includes('operator')) {
      // 🔥 Operadores usan rutas con /tabs/ para evitar destrucción de componentes
      this.pagesList = [
        'tabs/sip',
        'tabs/services',
        'tabs/scheduled',
        'tabs/taxi',
        'tabs/directions',
      ];
    }
  }

  async logout() {
    // 🔥 Si el usuario es operador y está conectado por SIP, deshabilitamos auto-conexión
    if (this.currentUser?.role?.includes('operator') && this.connectionStatus === 'connected') {
      await this.sip.disableAutoConnect();
      // 🔥 Realizamos logout después de desconectar SIP
      setTimeout(() => this.performLogout(), 500);
      return;
    }

    this.performLogout();
  }

  private performLogout() {
    // ANALYTICS y logout real
    const params: ParamType = {
      currentUserId: this.currentUser!.id
    };
    this.analytics.sendEventByType('logout', params);
    this.auth.logout();
  }

  async openLogsModal() {
    const modal = await this.modalCtrl.create({
      component: ConnectionLogsModalComponent,
      cssClass: 'logs-modal'
    });
    await modal.present();
  }

}
